import { Injectable } from "@angular/core";
import * as $RefParser from "@apidevtools/json-schema-ref-parser";

@Injectable({ providedIn: "root" })
export class SchemaService {
  constructor() {}

  /** Convenience Promise-based API */
  async getSchema(): Promise<any> {
    return $RefParser.dereference("/schemas/oasis.json");
  }
}
